// import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';

import 'bootstrap/dist/css/bootstrap.css';

import App from './components/App';
import * as serviceWorker from './serviceWorker';
import "./styles/all.min.css"


import "jquery";
import "featherlight/release/featherlight.min.css";
import "featherlight/release/featherlight.min.js";
import './styles/index.css';
import { BrowserRouter } from 'react-router-dom'


ReactDOM.render(<BrowserRouter> < App / ></BrowserRouter> , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();